import React from "react";
import { Box, Card, Flex, Heading, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const Tools = (): JSX.Element => {
  const tools = [
    {
      title: "Random password generator",
      description: "",
      urlSlug: "/random-password-generator",
    },
    {
      title: "Retirement calculator",
      description: "",
      urlSlug: "/retirement-calculator",
    },
    {
      title: "VIN details finder",
      description: "",
      urlSlug: "/vin-details-finder",
    },
  ];
  return (
    <Box width={"full"} textAlign={"center"}>
      <Heading>Tools</Heading>
      <Flex
        marginTop={6}
        justifyContent={"center"}
        wrap={"wrap"}
        alignItems={"stretch"}
        gap={6}
      >
        {tools.map((tool) => (
          <Card
            as={Link}
            variant={"custom"}
            width={{ base: "100%", md: "33.33%", lg: "calc(25% - 1.5rem)" }}
            to={`/tools${tool.urlSlug}`}
          >
            <Text fontSize={"1.2rem"} fontWeight={"bold"}>
              {tool.title}
            </Text>
            <Text>{tool.description}</Text>
          </Card>
        ))}
      </Flex>
    </Box>
  );
};

export default Tools;
